import { GcpRequestFileType } from '../gcpRequestFileType';
import { trackAction } from '../../../../../../libs/analytics/ActionTracking';
import { GcpRequestData, GcpRequestUploadFile, useUploadStore } from '../../../../../../store/uploadStore';
import { Customer, Site } from '../../../../../../types';

export const useHandleRemoveGcpFiles = (
  customer: Customer,
  site: Site,
  gcpRequest: GcpRequestData,
  type: GcpRequestFileType,
  files: string[],
  uploads: GcpRequestUploadFile[],
) => {
  const { setGcpRequest } = useUploadStore();

  return () => {
    uploads.forEach((upload) => upload.abortController.abort());
    uploads.splice(0, Infinity);
    files.splice(0, Infinity);
    if (type === GcpRequestFileType.Measurement) {
      gcpRequest.gcpCount = undefined;
      gcpRequest.restoredMeasurementParseResults = undefined;
    }
    setGcpRequest(customer.id, site.id, gcpRequest);
    if (type === GcpRequestFileType.Photo) {
      trackAction('Remove GCP photos', { customer, site });
    } else {
      trackAction('Remove GCP measurements', { customer, site });
    }
  };
};
